module.exports = DEF.TG.Details.extend({
	template: require('./device.html'),
});
